import { Directive, OnInit, signal } from '@angular/core';
import { BaseComponent, EventBusService, WindowService } from '@ups/xplat/core';
import { takeUntil } from 'rxjs/operators';

export interface InfoOverlayState {
  message?: string;
  show?: boolean;
  alignRight?: boolean;
}

@Directive()
export abstract class InfoOverlayBaseComponent
  extends BaseComponent
  implements OnInit
{
  // A signal: it is written from an event-bus subscription, not a template event, and the web
  // overlay is OnPush (WI 31712).
  readonly info = signal<InfoOverlayState | undefined>(undefined);

  constructor(
    protected win: WindowService,
    protected eventBus: EventBusService
  ) {
    super();
  }

  ngOnInit() {
    this.eventBus
      .observe(this.eventBus.types.updateInfoOverlay)
      .pipe(takeUntil(this.destroy$))
      .subscribe((data: InfoOverlayState) => {
        this.info.update((current) => ({
          ...(current || {}),
          ...(data || {}),
        }));
        if (this.info().show) {
          this.didShow();
        } else {
          this.didHide();
        }
      });
  }

  didShow() {
    // platforms can implement additional custom behavior
  }

  didHide() {
    // platforms can implement additional custom behavior
  }
}
